import { escape } from 'lodash'

// O Jodit sempre devolve o conteúdo começando por uma tag; texto puro com "<i>" no meio continua texto.
const LEADING_HTML_TAG_PATTERN = /^\s*<[a-z][a-z0-9]*(\s[^>]*)?\/?>/i

// Pareceres antigos são texto puro; os novos vêm em HTML do editor Jodit.
const formatOpinionHtml = (text) => {
  if (!text) return ''
  if (LEADING_HTML_TAG_PATTERN.test(text)) return text

  return escape(text).replace(/\r?\n/g, '<br />')
}

export default formatOpinionHtml
